import { UPDATEUSER_DATA } from "../constants/index";
const addUserState = {
  loading: false,
  err: "",
  success: false,
  userData: [],
};
export const UpdateUserReducer = (state = addUserState, action) => {
  switch (action.type) {
    case UPDATEUSER_DATA.UPDATE_DATA:
      return {
        ...state,
        loading: true,
        err: null,
        success: false,
      };
    case UPDATEUSER_DATA.UPDATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        err: null,
        userData: action.payload,
        success: true,
      };
    case UPDATEUSER_DATA.UPDATE_DATA_FAILED:
      return {
        ...state,
        loading: false,
        err: action.error,
        success: false,
      };

    default:
      return state;
  }
};
